import { render, staticRenderFns } from "./ResetSecurityProfileAddOtpComponent.vue?vue&type=template&id=e5f342e6&scoped=true"
import script from "./ResetSecurityProfileAddOtpComponent.vue?vue&type=script&lang=js"
export * from "./ResetSecurityProfileAddOtpComponent.vue?vue&type=script&lang=js"
import style0 from "./ResetSecurityProfileAddOtpComponent.vue?vue&type=style&index=0&id=e5f342e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f342e6",
  null
  
)

export default component.exports